import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Groups from "./pages/Groups";

import MenuBar from "./components/MenuBar";
import HighestScores from "./pages/HighestScores";
import DepartmentGroupScores from "./pages/DepartmentGroupScores";

const Layout = () => {
  return (
    <React.Fragment>
      <MenuBar />
      <Switch>
        <Route path="/voting/dashboard" component={Dashboard} />
        <Route path="/voting/groups" component={Groups} />
        <Route path="/voting/departments" component={DepartmentRouter} />
        <Route
          path="/voting/management/highest-scores"
          component={HighestScores}
        />

        <Route
          children={() => (
            <Redirect
              to={{
                pathname: "/voting/groups",
              }}
            />
          )}
          path="/voting"
        />
      </Switch>
    </React.Fragment>
  );
};

export default Layout;

const DepartmentRouter = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route
          path="/voting/departments/highest-scores"
          component={HighestScores}
        />

        <Route
          path="/voting/departments/group-scores"
          component={DepartmentGroupScores}
        />

        <Route
          path="/voting/departments/"
          component={() => <Redirect to="/voting/departments/highest-scores" />}
        />
      </Switch>
    </React.Fragment>
  );
};
